import { render, staticRenderFns } from "./UpdateUserGroupPage.vue?vue&type=template&id=3a39e900&scoped=true"
import script from "./UpdateUserGroupPage.vue?vue&type=script&lang=js"
export * from "./UpdateUserGroupPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a39e900",
  null
  
)

export default component.exports